import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: "https://mudeer.bishkar.com",
  //
  baseURL: "https://bebishkar.squaritive.com",
  // baseURL: "http://127.0.0.1:8000",
  headers: {
    "Content-Type": "application/json",
    //  "ngrok-skip-browser-warning": "true",
  },
});

export default axiosInstance;
